(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/register-new/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/register-new/constants.js');

const TEXTS = {
  HEADER_COMPANY: 'Företag',
  HEADER_CONTACT_PERSON: 'Kontaktperson'
};
svs.ticket_partner.digitalTickets.digitalTicketsForm.registerNew.constants = {
  TEXTS
};


 })(window);